import React from 'react'
import ReactDOM from 'react-dom/client'
import { initSentry } from './sentry'
import App from './App'
import { initializeNative } from './native'
import './index.css'

initSentry();
initializeNative();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
